const handleApiError = async (response) => {
    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        window.location.reload();
        throw new Error('Oturum süresi doldu veya yetkiniz yok.');
      }
      const errorData = await response.json();
      throw new Error(errorData.message || 'Hata oluştu');
    }
  };

  export const addExemptionRule = async (ruleData) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/exemption-rules`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(ruleData),
    });
    await handleApiError(response);
    return response.json();
  };

  export const fetchExemptionRules = async (buildingId) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/exemption-rules?buildingId=${buildingId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
    await handleApiError(response);
    return response.json();
  };

  export const updateExemptionRule = async (ruleId, ruleData) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/exemption-rules/${ruleId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(ruleData),
    });
    await handleApiError(response);
    return response.json();
  };

  export const deleteExemptionRule = async (ruleId) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/exemption-rules/${ruleId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
    await handleApiError(response);
    return response.json();
  };

  export const fetchExemptionRulesByDefinition = async (definitionId) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/exemption-rules/by-definition/${definitionId}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
    });
    await handleApiError(response);
    return response.json();
};
